import { AppAction, AppActionType } from '../actions/app';
import { RefundPolicyCode } from '../api/models/refundPolicy';
import { RespondentType } from '../models/questions';
import { AppNamespace } from '../state/app';

export const appReducer = (
    state: AppNamespace = {
        featureFlags: {},
        currencyFormat: '',
        defaultUserCountry: '',
        event: {
            id: '',
            organizer_id: '',
            survey_type: RespondentType.buyer,
        },
        isEventbriteTLD: true,
        locale: '',
        locales: [],
        request: {
            correlation_id: '',
            session_id: '',
            params: {},
        },
        splitIOProdKey: '',
        useAndroidProfile: false,
        useIosProfile: false,
        refundPolicyCode: RefundPolicyCode.notDefined,
        refundPolicyValidityDays: null,
    },
    action: AppAction,
) => {
    switch (action.type) {
        case AppActionType.initializeApp:
            return {
                ...state,
                ...action.payload,
            };

        case AppActionType.setReloadAfterCheckout: {
            return {
                ...state,
                reloadAfterCheckout: action.payload,
            };
        }

        case AppActionType.retrieveOrderFailure: {
            return {
                ...state,
                errors: [...(state.errors || []), action.payload],
            };
        }

        case AppActionType.removeAppError: {
            return {
                ...state,
                errors: state.errors?.filter(
                    (error) => error.error !== action.payload,
                ),
            };
        }

        case AppActionType.updatePayinLockStatus:
            return {
                ...state,
                payins: {
                    ...(state.payins || {}),
                    amountLocked: action.payload,
                },
            };

        case AppActionType.wasExternalPaymentWindowBlocked:
            return {
                ...state,
                wasExternalPaymentWindowBlocked: action.payload,
            };

        default:
            return state;
    }
};

const getWidgetParentUrl = (state: AppNamespace) => state.widgetParentUrl;

export const selectors = {
    getWidgetParentUrl,
};
